module.exports = __webpack_public_path__ + "static/kraken-3e819220bf6bf26eb0aab05517903d35.jpg";